import { render, staticRenderFns } from "./ButtonUp.vue?vue&type=template&id=3323233a&scoped=true"
import script from "./ButtonUp.vue?vue&type=script&lang=js"
export * from "./ButtonUp.vue?vue&type=script&lang=js"
import style0 from "./ButtonUp.vue?vue&type=style&index=0&id=3323233a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3323233a",
  null
  
)

export default component.exports